import {Brick, registerBrick} from 'olympe';

/**
 * Add a binding in a bindings object
 */
export default class OGAddBinding extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} bindings
     * @param {string} field
     * @param {string} value
     * @param {function(*)} setBindings
     */
    update($, [bindings, field, value], [setBindings]) {
        if (!bindings || !('bindings' in bindings)) {
            return;
        }

        const newBindings = {...bindings};
        newBindings.bindings[field] = value;

        setBindings(bindings);
    }
}

registerBrick('018925cac7e81ae5c804', OGAddBinding);
